import React from 'react';
import Loading from '../../Shared/Loading';
import Collection from '../CardCollection';

const SparkyardCollections = ({ collections, isLoading }) => (
  <>
    {isLoading && <Loading />}
    {collections?.map(({ id, title, albumArts, image }) => (
      <Collection
        key={id}
        id={id}
        title={title}
        albumArts={albumArts}
        image={image}
      />
    ))}
  </>
);

export default SparkyardCollections;
